export const prevArrow = `<button class="slick-arrow slick-prev nu-slick-arrow button" aria-label="Previous slide" type="button">
    ${Nu.prevArrow}
  </button>`;
export const nextArrow = `<button class="slick-arrow slick-next nu-slick-arrow button" aria-label="Next slide" type="button">
    ${Nu.nextArrow}
  </button>`;
